import React, { Fragment, useState } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { deleteProduct } from "../../../actions/product.action";
import { setAlert } from "../../../actions/alert";

const DeleteProduct = ({ deleteProduct, id, setAlert }) => {
  const [addModals, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const DeleteC = () => {
    deleteProduct(id);
    setAlert("تم حذف المنتج بنجاح", "success");
    setShow(false);
  };
  return (
    <Fragment>
      {/*  eslint-disable-next-line */}
      <a onClick={handleShow} className="text-danger">
        {" "}
        <FontAwesomeIcon icon={faTimes} />{" "}
      </a>
      <Modal show={addModals} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title> تأكيد الطلب </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ؟ هل انت متأكد انك تريد حدف هدا المنتج
          <Modal.Footer>
            <button
              className="btn-custom btn-dark center"
              onClick={handleClose}
            >
              لا
            </button>
            <button className="btn-custom btn-danger center" onClick={DeleteC}>
              نعم
            </button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default connect(null, {
  deleteProduct,
  setAlert,
})(DeleteProduct);
